module.exports = __webpack_public_path__ + "media/images/application/template/form-tick-b212df80903516b693d5c26d679ffd86.svg";